import React from 'react';
import QuestionEditor from './features/question-editor';
import './App.css';

function App() {
  return <QuestionEditor />;
}

export default App;
